import { Notifier } from '@airbrake/browser'

var airbrake = new Notifier({
  projectId: 1773,
  projectKey: '36e88dad54f754e13110dbfce213c0d7',
  host: 'https://errbit.enginearch.com',
  environment: process.env.VUE_APP_ENV,
  instrumentation: {
    console: false
  },
  keysBlocklist: [
    'password', // exact match
    /secret/ // regexp match
  ],
  reporter: 'xhr',
  remoteConfig: false
})

window.airbrake = airbrake
export default airbrake
